<script>
import { FilterIcon } from 'vue-feather-icons'
import FilterDrModal from './dr-filters-modal/cmp.vue'

export default {
  name: 'FilterButton',
  props: {
    search: Object,
  },
  computed: {
    areAnyfilters() {
      return !!this.search.statusIn.length
    },
  },
  methods: {
    openFilterModal() {
      this.$store.commit('modal/open', {
        cmp: FilterDrModal,
        animation: 'slide-down-menu',
        data: { search: this.search },
        callback: this.emitStatusChange,
      })
    },
    emitStatusChange(data) {
      this.$emit('satusInChange', data)
    },
  },
  components: {
    FilterIcon,
  },
}
</script>

<template lang="pug">
button.btn.btn-link.btn-filter.text-secondary.position-relative.pt-0.pb-0.pl-2.pr-2(
  @click="openFilterModal()"
  type="button"
)
  filter-icon(size="2x")
  .filter-amount-indicator(v-if="areAnyfilters")
</template>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.btn-filter {
  position: relative;

  .filter-amount-indicator {
    position: absolute;
    z-index: 1;
    width: 10px;
    height: 10px;
    background: $danger;
    right: 8px;
    bottom: 11px;
    border-radius: 100%;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.4);
  }
}
</style>
